import classNames from 'classnames';
import { forwardRef } from 'react';

import styles from './CustomButton.module.scss';

type AnchorProps = JSX.IntrinsicElements['a'];

const EditButton = forwardRef<HTMLAnchorElement, AnchorProps>(
  ({ className, title = 'edit', ...props }, ref) => {
    return (
      <a
        title={title}
        className={classNames(styles.linkToSettings, className)}
        {...props}
        ref={ref}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.6102 18.99L13.5302 9.90997C14.4602 7.56997 13.9802 4.80997 12.0902 2.90997C9.79021 0.609971 6.21021 0.399971 3.66021 2.25997L7.50021 6.10997L6.08021 7.51997L2.25021 3.68997C0.390206 6.22997 0.600206 9.81997 2.90021 12.11C4.76021 13.97 7.47021 14.46 9.79021 13.59L18.9002 22.7C19.2902 23.09 19.9202 23.09 20.3102 22.7L22.6102 20.4C23.0102 20.02 23.0102 19.39 22.6102 18.99ZM19.6102 20.59L10.1502 11.13C9.54021 11.58 8.86021 11.85 8.15021 11.95C6.79021 12.15 5.36021 11.74 4.32021 10.7C3.37021 9.75997 2.93021 8.49997 3.00021 7.25997L6.09021 10.35L10.3302 6.10997L7.24021 3.01997C8.48021 2.94997 9.73021 3.38997 10.6802 4.32997C11.7602 5.40997 12.1702 6.89997 11.9202 8.28997C11.8002 8.99997 11.5002 9.65997 11.0402 10.25L20.4902 19.7L19.6102 20.59Z"
            fill="currentColor"
          />
        </svg>
      </a>
    );
  }
);

export default EditButton;
